import { render, staticRenderFns } from "./loanPact.vue?vue&type=template&id=240bdc94&scoped=true"
var script = {}
import style0 from "./loanPact.vue?vue&type=style&index=0&id=240bdc94&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240bdc94",
  null
  
)

export default component.exports